import { Platform } from 'react-native';
export default {
  rowHeaderStyles: {
    fontSize: 16,
    color: "#006B95",
    fontWeight: "bold",
    alignItems: "center",
    backgroundColor: "#FFF"
  },
  rowHeaderChildrenSyles: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  rowHeaderContainerStyles: Platform.OS == "web" ? {
    backgroundColor: '#FFF',
    justifyContent: "center",
    paddingLeft: 10,
    borderRadius: 10,
    minHeight: 55
  } : {
    backgroundColor: '#FFF',
    justifyContent: "center",
    paddingLeft: 10,
    marginBottom: 10,
    marginTop: 10,
    borderRadius: 10,
    minHeight: 55
  },
  rowHeaderContainerStylesFirstChild: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row"
  },
  iconSpacing: Platform.OS === 'web' ? {
    alignItems: "flex-end",
    paddingRight: 15
  } : {
    alignSelf: "center",
    paddingRight: 15
  }
};